export const GLOBAL_FILTERS_ENTITY_NAME = 'GlobalFilters';
